// Settings (new interface, 10 October 2026): the account, the language, the team.
export default {
  titre: 'Settings',
  sousTitre: 'Your name, your language, your team',
  compte: 'My account',
  langue: 'Language',
  langueTexte: 'Orion’s language for you, on all your devices',
  theme: 'Appearance',
  themeTexte: 'Light, dark, or your system’s (it turns dark at night if your device does)',
  themeSysteme: 'System',
  themeClair: 'Light',
  themeSombre: 'Dark',
  equipe: 'Team',
  equipeTexte: 'Members, seats and roles of {organisation}',
  gererEquipe: 'Manage the team',
}
